// extracted by mini-css-extract-plugin
module.exports = {"customButtonStyle":"customButton_customButtonStyle__jbWJH"};